import { api } from "./client"

export type AuthUser = {
  id: string
  email: string | null
  full_name: string | null
  avatar_url: string | null
  is_superuser?: boolean
}

export type Organization = {
  id: string
  name: string
  slug: string
  logo_url: string | null
  plan: "free" | "pro" | "business"
}

export type Membership = {
  organization_id: string
  role: "owner" | "admin" | "recruiter" | "viewer"
  organization: Organization
}

export type Me =
  | { authenticated: false }
  | { authenticated: true; user: AuthUser; memberships: Membership[] }

export const authApi = {
  me: () => api<Me>("/auth/me"),
  signUp: (body: {
    email: string
    password: string
    full_name?: string
    org_name?: string
  }) =>
    api<{ ok: boolean; needs_email_confirmation: boolean; message?: string }>(
      "/auth/signup",
      { method: "POST", body },
    ),
  login: (body: { email: string; password: string }) =>
    api<{ ok: boolean }>("/auth/login", { method: "POST", body }),
  logout: () => api<{ ok: boolean }>("/auth/logout", { method: "POST" }),
  forgotPassword: (body: { email: string }) =>
    api<{ ok: boolean; message: string }>("/auth/forgot-password", {
      method: "POST",
      body,
    }),
  resetPassword: (body: { token: string; password: string }) =>
    api<{ ok: boolean }>("/auth/reset-password", { method: "POST", body }),
  verifyEmail: (body: { token: string }) =>
    api<{ ok: boolean }>("/auth/verify-email", { method: "POST", body }),
  onboarding: (body: { org_name: string }) =>
    api<{ ok: boolean; organization_id: string }>("/auth/onboarding", {
      method: "POST",
      body,
    }),
  switchOrg: (body: { organization_id: string }) =>
    api<{ ok: boolean }>("/auth/switch-org", { method: "POST", body }),
  invite: (body: { email: string; role: "admin" | "recruiter" | "viewer" }) =>
    api<{ ok: boolean }>("/auth/invite", { method: "POST", body }),
  acceptInvite: (token: string) =>
    api<{ ok: boolean; organization_id: string }>(
      `/auth/accept-invite/${encodeURIComponent(token)}`,
      { method: "POST" },
    ),
}
